module.exports = __webpack_public_path__ + "static/media/resi06.3d15e30e.jpeg";